import { createContext } from "react";

export const SharedContext = createContext(null);